module.exports = __webpack_public_path__ + "img/LogoDS-Values.bb07895f.png";